import React from "react"
import { useTranslation } from "react-i18next"

import { Card, Switch, } from "components"
import classes from "./PrinterOtherSettings.module.scss"
import clsx from "clsx"

const PrinterOtherSettings = props => {
  const { form, setForm } = props

  const [t, i18n] = useTranslation()

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <div className={classes["card"]}>
        <Card className={classes["category"]}>
          <div
            className={clsx(
              classes["category-text"],
              isLtr && classes["category-text-ltr"]
            )}
          >
            {t("پرینتر_کد_QR")}
          </div>
          <Switch
            checked={form.forQrTable}
            onClick={(value) => handleChange(value, "forQrTable")}
          />
        </Card>
      </div>

      <div className={classes["card"]}>
        <Card className={classes["category"]}>
          <div
            className={clsx(
              classes["category-text"],
              isLtr && classes["category-text-ltr"]
            )}
          >
            {t("پرینتر_گزارش_شیفت")}
          </div>
          <Switch
            checked={form.forShiftReport}
            onClick={(value) => handleChange(value, "forShiftReport")}
          />
        </Card>
      </div>

      <div className={classes["card"]}>
        <Card className={classes["category"]}>
          <div
            className={clsx(
              classes["category-text"],
              isLtr && classes["category-text-ltr"]
            )}
          >
            {t("پرینتر_رسید_مشتری")}
          </div>
          <Switch
            checked={form.forCustomer}
            onClick={(value) => handleChange(value, "forCustomer")}
          />
        </Card>
      </div>

      <div className={classes["card"]}>
        <Card className={classes["category"]}>
          <div
            className={clsx(
              classes["category-text"],
              isLtr && classes["category-text-ltr"]
            )}
          >
            {t("پرینتر_رسید_فروشگاه")}
          </div>
          <Switch
            checked={form.forKitchen}
            onClick={(value) => handleChange(value, "forKitchen")}
          />
        </Card>
      </div>

      <div className={classes["card"]}>
        <Card className={classes["category"]}>
          <div
            className={clsx(
              classes["category-text"],
              isLtr && classes["category-text-ltr"]
            )}
          >
            {t("پرینتر_تک_به_تک_آیتم_های_سفارش")}
          </div>
          <Switch
            checked={form.forOrderItems}
            onClick={(value) => handleChange(value, "forOrderItems")}
          />
        </Card>
      </div>

      {
        form.forOrderItems &&
        <div className={classes["card"]}>
          <Card className={classes["category"]}>
            <div
              className={clsx(
                classes["category-text"],
                isLtr && classes["category-text-ltr"]
              )}
            >
              {t("پرینتر_تک_به_تک_به_تعداد_آیتم_ها")}
            </div>
            <Switch
              checked={form.perOrderItemQuanity}
              onClick={(value) => handleChange(value, "perOrderItemQuanity")}
            />
          </Card>
        </div>
      }
    </div>
  )
}

export default PrinterOtherSettings